// extracted by mini-css-extract-plugin
export default {"serviceMessages":"ServiceMessages_serviceMessages"};